import React from "react";
import { connect } from "react-redux";
import ConfirmaContrasenia from "./confirmaContrasenia.cmpt";
import OpcionesEliminarCuenta from './opcionesEliminarCuenta.cmpt';
const mapState = (state) => {
    return {
        pasoEliminar: state.miPerfil.pasoEliminar,
    };
};

const mapDispatch = (dispatch) => {
    return {
        pasoSiguiente: () => {
            dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_ELIMINAR" });
        },
    };
};

class FlujoEliminar extends React.Component {


    render() {
        return (
            <div>
                <div>
                    {this.props.pasoEliminar === 0 &&
                        <OpcionesEliminarCuenta />
                    }
                    {this.props.pasoEliminar === 1 &&
                        <ConfirmaContrasenia />
                    }

                </div>
            </div>
        );
    }
}

export default connect(mapState, mapDispatch)(FlujoEliminar);


// WEBPACK FOOTER //
// ./src/miPerfil/flujoEliminar.cmpt.js